import IssueCountBadge from './IssueCountBadge';

export default IssueCountBadge;
